module.exports = __webpack_public_path__ + "30190b96bc67cf810a0762e3083fbf41.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room3/audio4/03_4MCA-Open-My-Glade.ogg
// module id = 779
// module chunks = 0